import Container from "./Container";
import hearts from "../../../public/wardrobe/hearts.jpg";
import SubmitButton from "./SubmitButton";
import ImgRadioButton from "./ImgRadioButton";
import Kreppirauta from "../../../public/graphics/krepatut.png";
import FlatIron from "../../../public/graphics/ponnari.png";
import Pompulat from "../../../public/graphics/pompulat.png";
import Klipsut from "../../../public/graphics/perhosklipsit.png";
import "../Styles/HairStation.css";
import { useState } from "react";
import { hideDialogue } from "../../helpers";

const HairStation = (props) => {
  const [koristeet, setKoristeet] = useState(null);
  const [tyyli, setTyyli] = useState(null);
  const handleOptionChange = (event) => {
    console.log("fire???");
    props.setDialogue(event.target.value);
    if (["krepattu", "suoristettu"].indexOf(event.target.name) > -1) {
      setTyyli(event.target.name);
    }
    console.log(event.target.name);
    if (["perhosklipsit", "pompulat"].indexOf(event.target.name) > -1) {
      setKoristeet(event.target.name);
    }
  };

  const formSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    const values = [];
    for (const value of data.entries()) {
      values.push(value[0]);
    }
    props.setSelectedHair(values);
    props.setVisibility(false);
    hideDialogue();
  };

  return (
    <>
      {props.visible && (
        <Container
          bgImg={hearts}
          class={"wardrobe-view-container"}
          headerText={"Hiukset"}
        >
          <p
            style={{
              fontSize: "large",
              fontWeight: "bold",
              textTransform: "uppercase",
              letterSpacing: "1.4px",
            }}
          >
            Tyyli
          </p>
          <form
            onSubmit={formSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div className="selection-container">
              <ImgRadioButton
                name="krepattu"
                value="Krepattu tukka ois varmaa hitti"
                checked={tyyli === "krepattu"}
                dialogueText={props.dialogueText}
                setDialogue={props.setDialogue}
                src={Kreppirauta}
                handleOptionChange={handleOptionChange}
                alt="kreppirauta"
              />
              <ImgRadioButton
                name="suoristettu"
                checked={tyyli === "suoristettu"}
                value="Suoristetut ois kivat sivuponnariin"
                dialogueText={props.dialogueText}
                setDialogue={props.setDialogue}
                src={FlatIron}
                handleOptionChange={handleOptionChange}
                alt="Suoristusrauta"
              />
            </div>
            <p
              style={{
                fontSize: "large",
                fontWeight: "bold",
                textTransform: "uppercase",
                letterSpacing: "1.4px",
              }}
            >
              Koristeet
            </p>
            <div className="selection-container">
              <ImgRadioButton
                name="perhosklipsit"
                value="Nää on kyl vaikee laittaa, mut vaivan arvosta!"
                checked={koristeet === "perhosklipsit"}
                dialogueText={props.dialogueText}
                setDialogue={props.setDialogue}
                src={Klipsut}
                handleOptionChange={handleOptionChange}
                alt="Perhosklipsut"
              />
              <ImgRadioButton
                name="pompulat"
                checked={koristeet === "pompulat"}
                value="Ponnari ei oo ikin huono valinta!"
                dialogueText={props.dialogueText}
                setDialogue={props.setDialogue}
                src={Pompulat}
                handleOptionChange={handleOptionChange}
                alt="Pompulat"
              />
            </div>
            <SubmitButton
              submit="handleHairSubmit"
              isSubmitType={true}
              text="Hiukset valmiina!"
              type="submit"
              disabled={!koristeet || !tyyli}
              setVisibility={props.setVisibility}
            />
          </form>
        </Container>
      )}
    </>
  );
};

export default HairStation;
